module.exports = __webpack_public_path__ + "img/tab_home_pre@2x.bbd356c6.png";